const VERBOTEN = /[/\\:*?"<>|]/g;

function sani(s: string): string {
  return (s ?? '').replace(VERBOTEN, ' ').replace(/\s+/g, ' ').trim();
}
function z2(n: number): string { return String(n).padStart(2, '0'); }

function escapeRegExp(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

// Prüft, ob `wort` als eigenständiges Wort (Wortgrenze) case-insensitive in `text` vorkommt.
function enthaeltWort(text: string, wort: string): boolean {
  if (!wort) return false;
  const re = new RegExp(`(^|\\W)${escapeRegExp(wort)}(\\W|$)`, 'i');
  return re.test(text);
}

export function dateiEndung(name: string): string {
  const m = /\.([A-Za-z0-9]+)$/.exec((name ?? '').trim());
  return m ? m[1].toLowerCase() : '';
}

export function loeseZielpfad(vorlage: string, datum: Date): string {
  return vorlage.replace(/\{Jahr\}/g, String(datum.getUTCFullYear()));
}

export function baueDateiname(p: {
  objektnummer?: string | null; datum: Date; dokumentWort: string; beschreibung: string; ext: string;
}): string {
  const nr = sani(p.objektnummer || '') || 'XXXX';
  const d = p.datum;
  // Deutsches Datumsformat TT_MM_JJJJ, VORANGESTELLT (User-Wunsch), danach Objektnummer, Dokumentwort, Beschreibung.
  const datumTeil = `${z2(d.getUTCDate())}_${z2(d.getUTCMonth() + 1)}_${d.getUTCFullYear()}`;
  const wortRoh = sani(p.dokumentWort);
  const besch = sani(p.beschreibung);
  // Füllwort "Dokument" (leer oder wörtlich, case-insensitive) entfällt ersatzlos; steckt das
  // Dokumentwort bereits in der Beschreibung, wird es nicht zusätzlich vorangestellt (keine Dopplung).
  const istFuellwort = !wortRoh || wortRoh.toLowerCase() === 'dokument';
  const wort = (istFuellwort || enthaeltWort(besch, wortRoh)) ? '' : wortRoh;
  const mittelteil = [wort, besch].filter(Boolean).join('_') || 'Anhang';
  const ext = (p.ext || '').toLowerCase().replace(/[^a-z0-9]/g, '') || 'bin';
  return `${datumTeil}_${nr}_${mittelteil}.${ext}`;
}
